var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"terra-x-nav-views"},[_c('button',{ref:"globe",class:[
      'terra-x-nav-views__button',
      'inverted',
      { active: _vm.isGlobeOpen } ],attrs:{"disabled":_vm.isGlobeButtonDisabled},on:{"click":_vm.globeOpen}},[_c('IconGlobe')],1),_vm._v(" "),_c('button',{class:[
      'terra-x-nav-views__button',
      'inverted',
      { active: !_vm.isGlobeOpen } ],on:{"click":_vm.globeClose}},[(_vm.type === 'projects')?_c('IconSearchProjects'):_c('IconSearchInvestors')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }